export function elements<T>(selector: string, parent: Element | Document = document): Array<T> {
    // converting NodeList to Array
    return Array.apply(null, parent.querySelectorAll(selector));
}
